<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { computed, onMounted } from "vue"
import { useStore } from "vuex"
import { useBreakpoint } from "@/app/Checkout/composables/useBreakpoint"

const store = useStore()
const { isMobile } = useBreakpoint()

const cartVouchers = computed(() => store.state.vouchers?.cartVouchers ?? [])
const redeemedCount = computed(() =>
  (cartVouchers.value || []).filter((v) => v.redeemed === true).length
)

const availableVouchers = computed(() =>
  (cartVouchers.value || []).filter((v) => v.redeemed === false && v.disabled === false).length
)

const isPending = computed(() => store.getters['vouchers/isPending'])
const error = computed(() => store.state.vouchers?.error)

onMounted(() => {
  store.dispatch('vouchers/getCartVouchers')
})

function openModal() {
  store.commit('vouchers/SET_VOUCHER_MODAL_VISIBLE', true)
}

function onBlockClick() {
  openModal()
}
</script>
